import clip from "text-clipper";

'use strict';

const utils = {
  // toggleClass: (elem) => {
  //  console.log(elem.dataset)
  //  let event = elem.dataset.toggleEvent;
  //  let className = elem.dataset.toggleClass;
  //  console.log(event)
  //   elem.addEventListener(event, e => {
  //     e.preventDefault()
  //     console.log(elem)
  //     elem.classList.toggle(className)
  //   })
  // },

  setCurrentLang: () => {
    const html = document.getElementsByTagName('html');
    const currentLang = html[0].getAttribute('lang');

    window.currentLang = currentLang;
  },
  debounce: (func, wait) => {
    let timeout;

    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };

      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },

  isSticky: (stickyElem, stickyClass, stickyReference = false) => {
    const observer = new IntersectionObserver(([e]) => {
      stickyElem.classList.toggle(stickyClass, e.intersectionRatio < 1);
    }, { threshold: [1] });

    if (stickyReference) {
      observer.observe(document.querySelector(stickyReference));
    } else {
      observer.observe(stickyElem);
    }
  },

  isInViewport: (elem, callback) => {
    let observer = new IntersectionObserver(entries => {
      for (let entry of entries) {
        callback(entry)
      }
    }, {
      threshold: 1
    });

    observer.observe(elem);
  },

  mq: {
    sm: window.matchMedia("(max-width: 768px)"),
    md: window.matchMedia("(max-width: 1024px)")
  },

  vars: {
    setVarHeight: function(varName, elem) {
      document.documentElement.style.setProperty(varName, `${utils.outerHeight(elem)}px`)
    },
    setVarWidth: function(varName, elem) {
      document.documentElement.style.setProperty(varName, `${elem.offsetWidth}px`)
    },
    headerSearchHeight: function() {
      let header = document.querySelector('.search-results-header');

      if (header) {
        this.setVarHeight('--headerSearchHeight', header)
        window.addEventListener('resize', e => {
          this.setVarHeight('--headerSearchHeight', header)
        })
      }
    },

    searchEngineHeight: function() {
      let searchEngine = document.querySelector('.search-engine');

      if (searchEngine) {
        this.setVarHeight('--searchEngineHeight', searchEngine)
        window.addEventListener('resize', e => {
          this.setVarHeight('--searchEngineHeight', searchEngine)
        })
      }
    },
    
    headerHeight: function() {
      let header = document.querySelector('#main-header');

      if (header) {
        this.setVarHeight('--headerHeight', header)
        window.addEventListener('resize', e => {
          this.setVarHeight('--headerHeight', header)
        })
      }
    },
    
    minisiteHeaderHeight: function() {
      let header = document.querySelector('#minisite-header');

      if (header) {
        this.setVarHeight('--headerHeight', header)
        window.addEventListener('resize', e => {
          this.setVarHeight('--headerHeight', header)
        })
      }
    },

    regionListWrapperWidth: function() {
      let regionListWrapper = document.querySelector('.region-list-wrapper');

      if (regionListWrapper) {
        this.setVarWidth('--regionListWrapperWidth', regionListWrapper)
        window.addEventListener('resize', e => {
          this.setVarWidth('--regionListWrapperWidth', regionListWrapper)
        })
      }
    }
  },

  outerHeight: function(element) {
    if (!element) {
      // console.log('Element is null');
      return 0;
    } else {
        const height = element.offsetHeight;
        const style = window.getComputedStyle(element);
        return ['top', 'bottom']
          .map(side => parseInt(style[`margin-${side}`]))
          .reduce((total, side) => total + side, height);
    }
    
  },

  wrap: function(toWrap, wrapper) {
    let newWrapper = document.createElement("div");
    toWrap.parentNode.appendChild(newWrapper);
    return newWrapper.appendChild(toWrap);
  },

  htmlStripTag: (htmlString) => {
    return htmlString.replace(/(<([^>]+)>)/gi, "");
  },

  truncateHtml: (htmlString, stringLength, params = {}) => {
    return clip(htmlString, parseInt(stringLength), { html: true, indicator: '...', ...params });
  },
  /** 
   * getSiblingsByClass()
   * 
   * example: utils.getSiblingsByClass(DOMElem, '.myClass')
   * return : all siblings with class .myClass
  */
  getSiblingsByClass: (elem, searchClass) => {
    let siblings = [];

    // if no parent, no siblings
    if(!elem.parentNode) {
      return siblings;
    }

    // first sibling
    let sibling  = elem.parentNode.firstChild;

    while (sibling) {
      const test1 = sibling.nodeType === 1;
      const test2 = sibling !== elem;
      const test3 = sibling.nodeType === 1 && sibling.classList.contains(searchClass);

      if (sibling.nodeType === 1 && sibling !== elem && sibling.classList.contains(searchClass)) {
        siblings.push(sibling);
      }

      // Jump to next sibling
      sibling = sibling.nextSibling;
    }

    return siblings;
  },
  prevUntil: (elem, selector, filter) => {
    // example: utils.prevUntil(DOMElem, '.endRange')
    let siblings = [];
    elem = elem.previousElementSibling;

    while (elem) {
      // If we've reached our match, bail
      if (elem.matches(selector)) {
        break
      }

      // If filtering by a selector, check if the sibling matches
      if (filter && !elem.matches(filter)) {
        elem = elem.previousElementSibling;
        continue;
      }

      // Otherwise, push it to the siblings array
      siblings.push(elem);
      elem = elem.previousElementSibling;
    }

    return siblings;
  },
  nextUntil: (elem, selector, filter) => {
    // example: utils.nextUntil(DOMElem, '.endRange')
    let siblings = [];
    elem = elem.nextElementSibling;

    while (elem) {
      // If we've reached our match, bail
      if (elem.matches(selector)) {
        break
      }

      // If filtering by a selector, check if the sibling matches
      if (filter && !elem.matches(filter)) {
        elem = elem.nextElementSibling;
        continue;
      }

      // Otherwise, push it to the siblings array
      siblings.push(elem);
      elem = elem.nextElementSibling;
    }

    return siblings;
  },
  updateURLParameter: (url, param, paramVal) => {
    let TheAnchor = null;
    let newAdditionalURL = "";
    let tempArray = url.split("?");
    let baseURL = tempArray[0];
    let additionalURL = tempArray[1];
    let temp = "";

    if (additionalURL) {
      const tmpAnchor = additionalURL.split("#");
      const TheParams = tmpAnchor[0];
      
      TheAnchor = tmpAnchor[1];
      if(TheAnchor) {
        additionalURL = TheParams;
      }

      tempArray = additionalURL.split("&");

      for (let i=0; i < tempArray.length; i++) {
        if(tempArray[i].split('=')[0] != param) {
          newAdditionalURL += temp + tempArray[i];
          temp = "&";
        }
      }
    } else {
      const tmpAnchor = baseURL.split("#");
      const TheParams = tmpAnchor[0];
      
      TheAnchor  = tmpAnchor[1];
      if(TheParams) {
        baseURL = TheParams;
      }
    }

    if(TheAnchor) {
      paramVal += "#" + TheAnchor;
    }

    const rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
  },
};

export default utils
